import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { AccommodationType } from '../types/entities/AccommodationType';

export const accommodationType: SchemaWithClient<AccommodationType> = {
  name: 'Accommodation Type',
  pluralName: 'Accommodation Type',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
    /*  prices: {
      name: 'Prices',
      fieldRenderer: SetField.tableAdapter(accommodationPrice),
      multiSwitchboard: true,
    },*/
  },
  client: new Client('/accommodation-types'),
};
